export default __webpack_public_path__ + "static/media/mysql.c88570bcc45e4d15aa2b92e17eef91dd.svg";